import React from 'react';
import PropTypes from 'prop-types';

const TooltipLearningObjectives = ({ tooltipTitle, tooltipText }) => {
  return (
    <div className="tooltip-learning-objectives">
      <span className="tooltip-learning-objectives__title">{tooltipTitle}</span>
      <span className="tooltip-learning-objectives__text">{tooltipText}</span>
    </div>
  );
};

TooltipLearningObjectives.propTypes = {
  tooltipTitle: PropTypes.string,
  tooltipText: PropTypes.string,
};

TooltipLearningObjectives.defaultProps = {};

export default TooltipLearningObjectives;
